import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=644de4f8&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=644de4f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644de4f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644de4f8')) {
      api.createRecord('644de4f8', component.options)
    } else {
      api.reload('644de4f8', component.options)
    }
    module.hot.accept("./InfoCard.vue?vue&type=template&id=644de4f8&scoped=true", function () {
      api.rerender('644de4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/InfoCard.vue"
export default component.exports